const LOCALHOST_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

type ServiceWorkerContainerLike = {
  register: (url: string) => Promise<unknown>;
};

type BrowserWindowLike = {
  isSecureContext?: boolean;
  location?: {
    hostname?: string;
  };
  addEventListener?: (event: string, listener: () => void) => void;
};

type BrowserGlobalsLike = {
  window?: BrowserWindowLike;
  navigator?: {
    serviceWorker?: ServiceWorkerContainerLike;
  };
  isSecureContext?: boolean;
  location?: {
    hostname?: string;
  };
};

function normalizeBasePath(basePath: string): string {
  const trimmed = basePath.trim();
  if (!trimmed || trimmed === "/") return "/";
  return `/${trimmed.replace(/^\/+|\/+$/g, "")}/`;
}

function getBrowserGlobals(): BrowserGlobalsLike {
  return globalThis as unknown as BrowserGlobalsLike;
}

function canRegisterServiceWorker(): boolean {
  const browser = getBrowserGlobals();
  const win = browser.window;
  const serviceWorker = browser.navigator?.serviceWorker;

  if (!win || !serviceWorker) {
    return false;
  }

  if (win.isSecureContext ?? browser.isSecureContext ?? false) {
    return true;
  }

  const hostname = win.location?.hostname ?? browser.location?.hostname ?? "";
  return LOCALHOST_HOSTNAMES.has(hostname);
}

export function registerServiceWorker(basePath: string): void {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  if (!canRegisterServiceWorker()) {
    return;
  }

  const browser = getBrowserGlobals();
  const win = browser.window;
  const serviceWorker = browser.navigator?.serviceWorker;

  if (!win?.addEventListener || !serviceWorker) {
    return;
  }

  const normalizedBase = normalizeBasePath(basePath);
  const swUrl = `${normalizedBase}sw.js`;

  win.addEventListener("load", () => {
    serviceWorker.register(swUrl).catch(() => {
      // Non-fatal: app should continue without install/offline enhancements.
    });
  });
}
